interface IOk<T> {
  ok: true;
  data: T;
}

interface IErr<E> {
  ok: false;
  error: E;
}

type Result<T, E> = IOk<T> | IErr<E>;

const Ok = <T>(data: T): IOk<T> => ({ ok: true, data });
const Err = <E>(error: E): IErr<E> => ({ ok: false, error });

export type { Result };
export { Ok, Err };
